import type {ReactElement} from 'react';
import {CreditBenefitItem} from '@Components/checkout-flow/components/credit-benefit-item/credit-benefit-item';
import {Text, TextSize, TextTag} from '@Components/text';
import {HOW_IT_WORKS_HEADING_ID, HOW_IT_WORKS_POINTS} from './ai-content-verify-how-it-works.types';
import styles from './ai-content-verify-how-it-works.module.scss';

export function AiContentVerifyHowItWorks(): ReactElement {
  return (
    <section aria-labelledby={HOW_IT_WORKS_HEADING_ID} className={styles.howItWorks}>
      <Text
        val={window.i18next.t('pmwjs_ai_verify_how_title')}
        tag={TextTag.H2}
        size={TextSize.LG}
        bold
        attributes={{id: HOW_IT_WORKS_HEADING_ID}}
        className={`ct-neutral-primary-on-dark ${styles.howItWorksTitle}`}
      />
      <ul className={styles.howItWorksList}>
        {HOW_IT_WORKS_POINTS.map((point) => {
          return <CreditBenefitItem key={point.titleKey} benefit={point} />;
        })}
      </ul>
    </section>
  );
}
